import type React from 'react';
import { useEffect, useState, cloneElement } from 'react';
import { useLocation } from 'react-router-dom';
import './AnimationWrapper.css';

interface AnimationWrapperProps {
	children: React.ReactElement;
}

const AnimationWrapper: React.FC<AnimationWrapperProps> = ({ children }) => {
	const location = useLocation();

	const [displayLocation, setDisplayLocation] = useState(location);
	const [transitionStage, setTransitionStage] = useState('zoom-in');

	useEffect(() => {
		if (location.pathname !== displayLocation.pathname) {
			setTransitionStage('zoom-out');
		}
	}, [location.pathname, displayLocation.pathname]);

	const handleTransitionEnd = () => {
		if (transitionStage === 'zoom-out') {
			setDisplayLocation(location);
			setTransitionStage('zoom-in');
		}
	};

	// This is the key that prevents the immediate content swap.
	const routeContent = cloneElement(children, { location: displayLocation });

	return (
		<div
			key={displayLocation.key}
			className={`page-transition-container ${transitionStage}`}
			onAnimationEnd={handleTransitionEnd}
		>
			<div className='page-content'>{routeContent}</div>
		</div>
	);
};

export default AnimationWrapper;
